import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Webinar01Component } from 'src/app/Components/webinar/webinar01/webinar01.component';
//import { Webinar012024Component } from 'src/app/Components/webinar/webinar012024/webinar012024.component';
import { Webinar02Component } from 'src/app/Components/webinar/webinar02/webinar02.component';
import { Webinar03Component } from 'src/app/Components/webinar/webinar03/webinar03.component';
import { Webinar04Component } from 'src/app/Components/webinar/webinar04/webinar04.component';
import { WebinarsComponent } from 'src/app/Components/webinar/webinars/webinars.component';


const routes: Routes = [
  { path: "", component: WebinarsComponent },
  //{ path: 'from-idea-to-impact-high-quality-content-creation-made-easy-with-specialized-ai-apps', component: Webinar012024Component },
  { path: 'how-to-use-ai-to-improve-your-academic-writing', component: Webinar01Component },
  { path: 'ai-for-accuracy-in-research-and-academic-writing', component: Webinar02Component },
  { path: 'using-ai-for-plagiarism-prevention-and-ai-content-detection', component: Webinar03Component },
  { path: 'improving-research-manuscripts-using-ai-powered-insights-enago-reports', component: Webinar04Component }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebinarsRoutingModule { }
